import { ChakraProvider, localStorageManager } from '@chakra-ui/react';
import '@fontsource/roboto';
import '@fontsource/roboto-condensed';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import './css/general.css';
import './css/golftec-font.css';
import { persistor, store } from './utils/store';
import extendedTheme from './utils/theme';
import LanguageProvider from './components/LanguageProvider';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import serviceWorker from './serviceWorker';

import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6';
import pkg from '../package.json';
import returnEnvDataDog from './components/CommonFunction/envDataDog';

const envDataDog = returnEnvDataDog();
const appId = process.env.REACT_APP_ID_DATADOG_ST;
const clientToken = process.env.REACT_APP_CLIENT_TOKEN_DATADOG_ST;
const site = process.env.REACT_APP_SITE_DATADOG;

if (window.location.hostname.match(/skytrakgolf.com|skytrakgolf.jp/)) {
  if (!appId || !clientToken || !site) {
    console.warn('Datadog config missing', {
      appId,
      clientToken,
      site,
    });
  } else {
    datadogRum.init({
      applicationId: appId,
      clientToken,
      site,
      service: 'skytrak-clubhouse',
      env: envDataDog, // e.g. 'prod', 'staging-1', 'dev'
      version: pkg?.version, // e.g. '1.0.0'
      sessionSampleRate: 100, // capture 100% of sessions
      sessionReplaySampleRate: 20, // capture 20% of sessions with replay
      trackResources: true, // Enable Resource tracking
      trackUserInteractions: true, // Enable Action tracking
      trackLongTasks: true, // Enable Long Tasks tracking

      plugins: [reactPlugin({ router: true })],
    });
  }
}

const router = createBrowserRouter([
  {
    path: '/*',
    element: <App />,
  },
]);

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ChakraProvider
        theme={extendedTheme}
        colorModeManager={localStorageManager}
      >
        <LanguageProvider>
          <RouterProvider
            router={router}
            future={{
              v7_startTransition: true,
            }}
          />
        </LanguageProvider>
      </ChakraProvider>
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker();
reportWebVitals();
